import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  customConvertIntoSelect2OptionsClasses,
  getFetchOptions,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";
import { useLocation } from "react-router-dom";

const AddStudent = () => {
  const [provsOption, setProvsOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);
  const [schoolOption, setSchoolOption] = useState([]);
  const [schoolsFullData, setSchoolsFullData] = useState([]);
  const [classOption, setClassOption] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedSchool, setSelectedSchool] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [fiscalCode, setFiscalCode] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("123");
  const [codiceAlunno, setCodiceAlunno] = useState("");
  const [avatar, setAvatar] = useState(null);

  const currentMonth = new Date().getMonth();
  const schoolYear =
    currentMonth >= 8
      ? `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
      : `${new Date().getFullYear() - 1}${new Date().getFullYear()}`;

  const [loadedData, setLoadedData] = useState(false);
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();

  const breadcrumb = {
    current_section: "Studenti",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Classi", route_name: null, params: [] },
      { name: "Studenti", route_name: null, params: [] },
      { name: "Nuovo", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();

        result.provincie.sort((a, b) => a.nome.localeCompare(b.nome));
        setProvsOption(
          convertIntoSelect2Options(result.provincie, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );
        const result = await response.json();
        setSchoolsFullData(result.return.scuola);
        setSchoolOption(
          convertIntoSelect2Options(result.return.scuola, "id", "denomistituto")
        );
      } catch (error) {
        console.error(error);
      }
    };

    Promise.all([fetchProvs(), fetchSchools()]).then(() => {
      setLoadedData(true);
    });
  }, []);

  useEffect(() => {
    const schoolIdFromUrl = query.get("schoolId");
    const classIdFromUrl = query.get("classId");

    if (schoolIdFromUrl && schoolOption.length > 0) {
      handleSchoolChange({
        value: schoolIdFromUrl,
      });
    }

    if (classIdFromUrl) {
      handleClassChange({
        value: classIdFromUrl,
      });
    }
  }, [loadedData]);

  useEffect(() => {
    const fetchSchoolsFiltered = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getSchools?idprov=${
            selectedProvince ?? ""
          }&townId=${selectedCity ?? ""}`,
          fetchOptions
        );
        const result = await response.json();

        setSchoolOption(
          convertIntoSelect2Options(result, "id", "denomistituto")
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchSchoolsFiltered();
  }, [selectedProvince, selectedCity]);

  // Funzione per validare il codice fiscale italiano
  const isValidCF = (cf) => {
    if (!cf) return false;
    const regex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
    return regex.test(cf);
  };
  // Stato per gestire l'errore del codice fiscale
  const [cfError, setCfError] = useState("");
  const isValidEmail = (email) => {
    if (!email) return false;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const [emailError, setEmailError] = useState("");
  // Modifica handleSave per controllare il codice fiscale
  const handleSaveWithCFCheck = async () => {
    let hasError = false;

    if (!isValidCF(fiscalCode)) {
      setCfError("Codice fiscale non valido");
      hasError = true;
    } else {
      setCfError("");
    }

    if (!isValidEmail(email)) {
      setEmailError("Email non valida");
      hasError = true;
    } else {
      setEmailError("");
    }

    if (hasError) return;

    await handleSave();
  };

  const handleAvatarChange = (e) => {
    const selectedFile = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setAvatar(reader.result);
    };

    reader.readAsDataURL(selectedFile);
  };

  const handleProvinceChange = async (event) => {
    setSelectedProvince(event?.value);

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${event?.value}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOption(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };

    fetchCities();
  };

  const handleCityChange = (event) => {
    setSelectedCity(event?.value);
  };

  const handleSchoolChange = async (event) => {
    setSelectedSchool(event?.value);

    handleProvinceChange({
      value:
        schoolsFullData.find((s) => s.id == event?.value)?.idprovincia || "",
    });

    handleCityChange({
      value: schoolsFullData.find((s) => s.id == event?.value)?.idcomune || "",
    });

    try {
      const fetchOptions = getFetchOptions(
        "application/x-www-form-urlencoded",
        [],
        "GET"
      );
      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/getAllClasses?schoolId=${event?.value}&schoolYear=${schoolYear}`,
        fetchOptions
      );
      const result = await response.json();
      if (result.error) {
        alert("Errore durante il caricamento delle classi");
        console.error("Error fetching classes:", result.error);
        return;
      }
      setClassOption(
        customConvertIntoSelect2OptionsClasses(
          result,
          "idclassi",
          "classe",
          "sezione"
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleClassChange = (event) => {
    setSelectedClass(event?.value);
  };

  const handleSave = async () => {
    if (
      !selectedProvince ||
      !selectedCity ||
      !selectedSchool ||
      !selectedClass
    ) {
      alert("Provincia, Comune, Scuola e Classe sono obbligatori");
      return;
    }

    if (!name) {
      alert("Il campo Nome è obbligatorio");
      return;
    }
    if (!surname) {
      alert("Il campo Cognome è obbligatorio");
      return;
    }
    if (!fiscalCode) {
      alert("Il campo Codice Fiscale è obbligatorio");
      return;
    }
    if (!birthDate) {
      alert("Il campo Data di Nascita è obbligatorio");
      return;
    }
    if (!email) {
      alert("Il campo Email è obbligatorio");
      return;
    }
    if (!codiceAlunno) {
      alert("Il campo Codice Alunno è obbligatorio");
      return;
    }

    const checkResponse = await fetch(
      `${axios.defaults.baseBFFUrl}/fe/checkStudentEmailAndCF?email=${email}&cf=${fiscalCode}`,
      getFetchOptions("application/json", {}, "GET")
    );
    const checkResult = await checkResponse.json();

    if (checkResult.emailExists) {
      setEmailError("Email già utilizzata da un altro studente");
      return;
    }

    if (checkResult.cfExists) {
      setCfError("Codice Fiscale già utilizzato da un altro studente");
      return;
    }

    const checkResponseCode = await fetch(
      `${axios.defaults.baseBFFUrl}/fe/checkStudentCode?schoolId=${selectedSchool}&studentCode=${codiceAlunno}&schoolYear=${schoolYear}`,
      getFetchOptions("application/json", {}, "GET")
    );

    const checkResultCode = await checkResponseCode.json();
    if (checkResultCode.error || checkResultCode.exists) {
      alert("Codice Alunno già utilizzato da un altro studente");
      return;
    }

    let formData = {};
    formData["idscuole"] = selectedSchool;
    formData["idclasse"] = selectedClass;
    formData["nome"] = name;
    formData["cognome"] = surname;
    formData["codicefiscale"] = fiscalCode;
    formData["birthdate"] = birthDate;
    formData["telefono"] = phone;
    formData["email"] = email;
    formData["pwd"] = password;
    formData["immagine"] = avatar;
    formData["annoscolastico"] = schoolYear;
    formData["inviapuntiastudente"] = 1;
    formData["codicealunno"] = codiceAlunno;
    formData["nickname"] = `${name.charAt(0)}${surname.replace(/\s/g, "")}`;

    const fetchOptions = getFetchOptions(
      "application/json",
      { student: formData },
      "POST"
    );
    fetch(`${axios.defaults.baseBFFUrl}/fe/addStudent`, fetchOptions).then(
      () => {
        window.location = "/students";
      }
    );
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a href="/students">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista studenti
        </button>
      </a>
      <br />
      <label className="mb-4">
        <b>(*) Campo obbligatorio</b>
      </label>

      {/* <div className="card custom-card">
        <div className="card-header">Immagine del profilo</div>
        <div className="card-body">
          <div className="row row-cols-1 row-cols-lg-2 align-items-center">
            {avatar && (
              <div className="col">
                <span
                  className="avatar"
                  style={{ backgroundImage: `url(${avatar})` }}
                ></span>
              </div>
            )}
            <div className="col">
              <div className="input-group">
                <input
                  type="file"
                  className="form-control"
                  id="avatar"
                  aria-describedby="btnAvatar"
                  onChange={handleAvatarChange}
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  id="btnAvatar"
                >
                  Carica
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Student Data Form */}
      <div className="card custom-card">
        <div className="card-header">Dati studente</div>
        <div className="card-body">
          <div className="row">
            <div className="col-12 col-lg-3">
              <label htmlFor="province">
                Provincia <b>*</b>
              </label>
              <Select
                options={provsOption}
                id="province"
                name="province"
                value={provsOption.filter(function (option) {
                  return option.value == Number(selectedProvince);
                })}
                onChange={handleProvinceChange}
                classNames={"form-control"}
                placeholder="Scegli provincia..."
                isSearchable
                isClearable
              />
            </div>

            <div className="col-12 col-lg-3">
              <label htmlFor="city">
                Comune <b>*</b>
              </label>
              <Select
                options={cityOption}
                id="city"
                name="city"
                value={cityOption?.filter(function (option) {
                  return option.value == Number(selectedCity);
                })}
                onChange={handleCityChange}
                classNames={"form-control"}
                placeholder="Scegli comune..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col-12 col-lg-3">
              <label htmlFor="school">
                Scuola <b>*</b>
              </label>
              <Select
                options={schoolOption}
                id="school"
                name="school"
                value={schoolOption?.filter(function (option) {
                  return option.value == Number(selectedSchool);
                })}
                onChange={handleSchoolChange}
                classNames={"form-control"}
                placeholder="Scegli scuola..."
                isSearchable
                isClearable
              />
            </div>

            <div className="col-12 col-lg-3">
              <label htmlFor="classe">
                Classe <b>*</b>
              </label>
              <Select
                options={classOption}
                id="classe"
                name="classe"
                value={classOption?.filter(function (option) {
                  return option.value == Number(selectedClass);
                })}
                onChange={handleClassChange}
                classNames={"form-control"}
                placeholder="Scegli classe..."
                isSearchable
                isClearable
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-2">
              <div className="form-group">
                <label htmlFor="codicealunno">
                  Codice Alunno <b>*</b>
                </label>
                <input
                  type="text"
                  id="codicealunno"
                  name="codicealunno"
                  value={codiceAlunno}
                  onChange={(e) => setCodiceAlunno(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group">
                <label htmlFor="name">
                  Nome <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="name"
                  name="nome"
                  value={name || ""}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </div>

            <div className="col-12 col-lg-3">
              <div className="form-group">
                <label htmlFor="cognome">
                  Cognome <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="cognome"
                  name="cognome"
                  value={surname || ""}
                  onChange={(e) => setSurname(e.target.value)}
                />
              </div>
            </div>

            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="fiscalCode">
                  Codice Fiscale <b>*</b>
                </label>
                <input
                  className={`form-control ${cfError ? "is-invalid" : ""}`}
                  id="cf"
                  name="cf"
                  label="Codice fiscale"
                  value={fiscalCode}
                  onChange={(e) => {
                    setFiscalCode(e.target.value);
                    if (cfError) setCfError("");
                  }}
                />
                {cfError && <div className="invalid-feedback">{cfError}</div>}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="birthDate">
                  Data di nascita <b>*</b>
                </label>
                <input
                  className="form-control"
                  type="date"
                  id="birthDate"
                  name="birthDate"
                  value={birthDate || ""}
                  onChange={(e) => setBirthDate(e.target.value)}
                />
              </div>
            </div>

            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="email">
                  Email <b>*</b>
                </label>
                <input
                  className={`form-control ${emailError ? "is-invalid" : ""}`}
                  id="email"
                  name="email"
                  label="Email"
                  value={email || ""}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (emailError) setEmailError("");
                  }}
                />
                {emailError && (
                  <div className="invalid-feedback">{emailError}</div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="phone">Telefono</label>
                <input
                  className="form-control"
                  id="phone"
                  name="phone"
                  type="number"
                  value={phone || ""}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Save Button */}
          <div className="col-12">
            <div className="form-group">
              <div className="saveButtonContainer">
                <button
                  id="btnSave"
                  name="btnSave"
                  className="btn btn-success saveButton"
                  type="button"
                  onClick={handleSaveWithCFCheck}
                >
                  &nbsp;Salva
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStudent;
